import React from "react";
import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const paperSx = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100vh - 64px)",
};

const headerSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#36345a",
  padding: "16px 24px",
  flexShrink: 0,
};

const headerTitleSx = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
};

const titleSx = {
  color: "#fff",
  fontWeight: "bold",
  fontSize: "18px",
};

const closeIconSx = {
  color: "#fff",
};

const bodySx = {
  padding: "24px",
  overflowY: "auto",
  flex: "1 1 auto",
};

const footerWrapperSx = {
  flexShrink: 0,
};

const Modal = ({
  open,
  onClose,
  icon,
  title,
  children,
  footer,
  bodySx: bodySxOverride,
  maxWidth,
  maxHeight,
  PaperProps,
  ...dialogProps
}) => (
  <Dialog
    open={open}
    onClose={(event, reason) => {
      if (reason === "backdropClick") return;
      if (onClose) onClose(event, reason);
    }}
    maxWidth={false}
    fullWidth
    PaperProps={{
      ...PaperProps,
      sx: [
        paperSx,
        maxWidth != null && {
          maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
        },
        maxHeight != null && {
          maxHeight:
            typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight,
        },
        PaperProps?.sx,
      ],
    }}
    {...dialogProps}
  >
    <Box sx={headerSx}>
      <Box sx={headerTitleSx}>
        {icon}
        <Box component="span" sx={titleSx}>
          {title}
        </Box>
      </Box>

      <IconButton onClick={onClose} size="small">
        <CloseIcon sx={closeIconSx} />
      </IconButton>
    </Box>

    <Box sx={[bodySx, bodySxOverride]}>{children}</Box>

    {footer && <Box sx={footerWrapperSx}>{footer}</Box>}
  </Dialog>
);

export default React.memo(Modal);
